import script from "./CommentInput.vue?vue&type=script&setup=true&lang=js"
export * from "./CommentInput.vue?vue&type=script&setup=true&lang=js"

import "./CommentInput.vue?vue&type=style&index=0&id=5c06b530&lang=css"

const __exports__ = script;

export default __exports__